export default {
  name: 'ListPagination',

  data() {
    return {
      keyword: '',
      per_page: 10,
      current_page: 1
    };
  },
  watch: {
    keyword(val) {
      VueEventHub.$emit('search-student', val);
    }
  },
  computed: {
    filteredData() {
      if (!this.keyword.trim()) {
        return this.items.slice(this.offset, this.nextToTake);
      }

      return this.items
        .filter(item => this.filter(item))
        .slice(this.offset, this.nextToTake);
    },

    pages() {
      return Math.ceil(
        (this.keyword.trim() ? this.filteredData.length : this.items.length) /
          this.per_page,
      );
    },

    offset() {
      return (this.current_page - 1) * this.per_page;
    },

    nextToTake() {
      return this.offset + this.per_page;
    },

    perPage() {
      const pages = [];
      for (let i = 10; i <= 50; i += 10) {
        pages.push(i);
      }

      return pages;
    }
  },
  mounted() {
    VueEventHub.$on('search-student', this.setKeyword);
  },
  methods: {
    setPage(index) {
      if (index >= 1 && index <= this.pages) {
        this.current_page = index;
      }
    },
    setKeyword(val) {
      if (val !== this.keyword) {
        this.keyword = val;
      }
    }
  }
};
